module.exports = __webpack_public_path__ + "img/ticket.25852544.png";